import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
import { subsections } from './utils/sections';

/** First chosen section that has subsections but none of them chosen (mirrors RequireSubsection.php). */
export function sectionMissingSubsection(tags) {
  return tags.find(tag => !tag.isChild() && tag.position() !== null && subsections(tag).length > 0 && !tags.some(t => t.parent() === tag));
}
const MODAL = 'ext:flarum/tags/forum/components/TagDiscussionModal';
export default function addSubsectionRule() {
  // The tag picker cannot be confirmed while a section with subsections lacks one…
  override(MODAL, 'meetsRequirements', function (original) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return original(...args) && !sectionMissingSubsection(this.selected);
  });

  // …and says what is missing instead of the generic "choose N more tags".
  override(MODAL, 'getInstruction', function (original) {
    const missing = sectionMissingSubsection(this.selected);
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    const instruction = original(...args);
    if (missing && instruction === '') {
      return app.translator.trans('tarotportal-theme.forum.composer.choose_subsection', {
        section: missing.name()
      }, true);
    }

    // core: "Укажите основной тег" → what to do in this forum's words
    return instruction === '' ? '' : app.translator.trans('tarotportal-theme.forum.composer.choose_section', {}, true);
  });

  // Plain words: "Раздел и подраздел" (with the discussion's title when moving an existing one), not tags
  override(MODAL, 'title', function () {
    const title = app.translator.trans('tarotportal-theme.forum.composer.picker_title', {}, true);
    return this.attrs.discussion ? `${title}: «${this.attrs.discussion.title()}»` : title;
  });

  // The whole structure at once: every section with its subsections under it (core shows a
  // section's subsections only after the section is chosen). Choosing a subsection still adds
  // its section (core's requireParentTag), and core's limits still apply: subsections of a
  // section that can no longer be chosen are left out. A search shows matches with their section.
  override(MODAL, 'getFilteredTags', function (original) {
    const query = String(this.filter() || '').toLowerCase();
    const requireParent = this.attrs.requireParentTag;
    this.filter('');
    this.attrs.requireParentTag = false;
    let tags;
    try {
      tags = original();
    } finally {
      this.attrs.requireParentTag = requireParent;
      this.filter(query);
    }
    tags = tags.filter(tag => {
      const parent = tag.parent();
      return !parent || tags.includes(parent) || this.selected.includes(parent);
    });
    if (query) {
      const matches = tag => tag.name().toLowerCase().includes(query);
      tags = tags.filter(tag => matches(tag) || !tag.parent() && tags.some(child => child.parent() === tag && matches(child)));
    }
    if (!this.indexTag || !tags.includes(this.indexTag)) this.indexTag = tags[0];
    return tags;
  });

  // A discussion started from a section page has only the section preselected: ask for the subsection
  // before submitting rather than letting the server reject it.
  override('flarum/forum/components/DiscussionComposer', 'onsubmit', function (original) {
    const chosen = this.composer.fields.tags || [];
    if (!sectionMissingSubsection(chosen)) return original();
    app.modal.show(() => flarum.reg.asyncModuleImport('ext:flarum/tags/forum/components/TagDiscussionModal'), {
      selectedTags: chosen.slice(0),
      onsubmit: tags => {
        this.composer.fields.tags = tags;
        original();
      }
    });
  });
}